import { jsx as o, jsxs as r } from "react/jsx-runtime";
import { R as m, a as y, e as h, c as R } from "../chunks/List.97cc6348.js";
import n, { useEffect as S } from "react";
import l from "styled-components";
import { u } from "../chunks/useForwardRef.7bf5d172.js";
const L = n.forwardRef(({
  ...t
}, e) => /* @__PURE__ */ o(m, { ...t, ref: e }));
L.displayName = "RangoListSelectLabel";
const C = n.forwardRef(({
  ...t
}, e) => /* @__PURE__ */ o(y, { ...t, ref: e }));
C.displayName = "RangoListContentType";
const w = l.div.withConfig({
  displayName: "SlotStart",
  componentId: "sc-12h1t5b-0"
})(["display:flex;align-items:center;justify-content:flex-start;gap:var(--spacing-2x);"]), x = l.div.withConfig({
  displayName: "SlotEnd",
  componentId: "sc-12h1t5b-1"
})(["display:flex;align-items:center;justify-content:flex-end;"]), N = l(h("div")).withConfig({
  displayName: "ListSelect",
  componentId: "sc-12h1t5b-2"
})(["padding-right:", ";"], ({
  $isSwitch: t
}) => t ? "var(--spacing-1_5x)" : "var(--spacing-half)"), b = n.forwardRef(({
  children: t,
  ...e
}, c) => {
  const [d, s] = n.useState(!1), f = u(c);
  S(() => {
    g();
  }, [t]);
  const g = () => {
    const i = a("input")[0];
    if (!i) {
      s(!1);
      return;
    }
    i.type.displayName === "RangoSwitch" ? s(!0) : s(!1);
  }, a = (i) => n.Children.toArray(t).filter((p) => p.props.slot === i);
  return /* @__PURE__ */ r(N, { $isSwitch: d, $isClickMotion: !1, onClick: e == null ? void 0 : e.onClick, ref: f, type: R.Outline, "data-testid": "rango-list-select", "data-rango-component": "rango-list-select", "data-is-rango": !0, ...e, children: [
    /* @__PURE__ */ r(w, { children: [
      a("type"),
      a("label")
    ] }),
    /* @__PURE__ */ o(x, { children: a("input") })
  ] });
});
b.displayName = "RangoListContent";
export {
  b as RangoListSelect,
  L as RangoListSelectLabel,
  C as RangoListSelectType
};
